import defectMarkup from '@/store/modules/viewer/modules/defectMarkup';
import plan from '@/store/modules/viewer/modules/plan';
import point from '@/store/modules/viewer/modules/point'

export default {
  namespaced: true,
  modules: { defectMarkup, plan, point }
};

